import { render, staticRenderFns } from "./statement_of_conflict_of_interest.vue?vue&type=template&id=44b454a1"
import script from "./statement_of_conflict_of_interest.vue?vue&type=script&lang=js"
export * from "./statement_of_conflict_of_interest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports